import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import Swal from "sweetalert2";
import useAuthUser from "../../../../auth/getUser";

const PostAJob = () => {
  const { user } = useAuthUser();
  console.log(user);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  // const stripHtmlTags = (str) => {
  //   if (!str) return str;
  //   return str.replace(/<\/?[^>]+(>|$)/g, "");
  // };

  const onSubmit = async (data) => {
    const [min, max] = data.salary.split("-").map(Number);
    const formattedSalary = `$${min}/hr - $${max}/hr`;

    const cleanedData = {
      ...data,
      job_description: data.description || data.job_description,
      job_requirements: data.requiments || data.job_requirements,
      postby: user.name,
      postbyId: user?._id,
      salary: formattedSalary,
    };

    const historyData = {
      designation: data.job_title,
      posted_date: new Date(),
      active: 10,
      awaiting: 5,
      conducting: 2,
      location: data.location,
    };

    // console.log(data);
    // console.log(historyData);

    try {
      // console.log(data);
      await axios.post(
        `${process.env.REACT_APP_BASE_API}/postjobs`,
        cleanedData
      );

      await axios.post(
        `${process.env.REACT_APP_BASE_API}/history`,
        historyData
      );

      Swal.fire(
        {
          title: "Success!",
          text: "Job posted successfully",
          icon: "success",
          confirmButtonText: "OK",
        },

        reset()
      );
    } catch (error) {
      console.error("There was an error posting the job!", error);
      Swal.fire({
        title: "Error!",
        text: "There was an error posting the job",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const validateSalary = (value) => {
    // Check if the value is in the correct format (e.g., 3-10)
    const regex = /^(\d+)-(\d+)$/;
    const match = value.match(regex);
    if (!match) {
      return "Invalid format. Use the format 'min-max'";
    }

    const [_, min, max] = match.map(Number);
    if (min < 3) {
      return "The first value should not be less than 3";
    }
    if (max > 99) {
      return "The second value should not be more than 99";
    }

    return true;
  };

  const jobDescription = watch("job_description");
  const jobRequirements = watch("job_requirements");
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="card-body">
        <div className="form-control">
          <label className="label">
            <span className="font-semibold ">Job Title</span>
          </label>
          <input
            type="text"
            placeholder="job title"
            className="input input-sm !bg-white input-bordered rounded-2xl"
            {...register("job_title", { required: true })}
          />
          {errors.job_title && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>

        <div className="mt-3 form-control">
          <label className="label">
            <span className="font-semibold ">Job Headline</span>
          </label>
          <p className="label-text">Write Compelling Headlines</p>
          <input
            type="text"
            placeholder="Answer"
            className="input input-sm !bg-white input-bordered rounded-2xl"
            {...register("job_headline", { required: true })}
          />
          {errors.job_headline && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>

        <div className="grid gap-2 md:grid-cols-2">
          <div className="mt-3 form-control ">
            <label>Job Type</label>
            <select
              {...register("job_type")}
              className="p-1 rounded-xl bg-base-100"
            >
              <option value="full time">Full time</option>
              <option value="part time">Part time</option>
            </select>
            {errors.job_type && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
          <div className="mt-3 form-control">
            <label>Hour per week</label>
            <select
              {...register("hour_per_week")}
              className="p-1 rounded-xl bg-base-100"
            >
              <option value="40">40</option>
              <option value="25">25</option>
              <option value="30">30</option>
            </select>
            {errors.hour_per_week && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        <div className="grid gap-2 md:grid-cols-2 ">
          <div className="mt-3 form-control">
            <label className="label">
              <span className="font-semibold ">Company</span>
            </label>

            <input
              type="text"
              placeholder="Answer"
              className="input input-sm !bg-white input-bordered rounded-2xl"
              {...register("company", { required: true })}
            />
            {errors.company && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="mt-3 form-control">
            <label className="label">
              <span className="font-semibold ">Location</span>
            </label>

            <input
              type="text"
              placeholder="Answer"
              className="input input-sm !bg-white input-bordered rounded-2xl"
              {...register("location", { required: true })}
            />
            {errors.location && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        <div className="grid gap-2 md:grid-cols-2 ">
          <div className="mt-3 form-control">
            <label className="label">
              <span className="font-semibold ">Industry</span>
            </label>

            <input
              type="text"
              placeholder="Answer"
              className="input input-sm !bg-white input-bordered rounded-2xl"
              {...register("industry", { required: true })}
            />
            {errors.industry && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="mt-3 form-control">
            <label className="label">
              <span className="font-semibold ">Size of Company</span>
            </label>

            <input
              type="text"
              placeholder="Answer"
              className="input input-sm !bg-white input-bordered rounded-2xl"
              {...register("size_of_company", { required: true })}
            />
            {errors.size_of_company && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>
        </div>

        <div className="mt-3 form-control">
          <label className="label">
            <span className="font-semibold ">Salary</span>
          </label>
          <p className="label-text ">
            How much (US Dollar) do you want to pay per Hour? the salary range
            is between $3.00 and $99.00
          </p>
          <div className="flex flex-col w-full gap-2 mt-1 md:flex-row">
            <div className="flex flex-col w-full gap-y-1">
              <input
                type="text"
                placeholder="Answer"
                className="input input-sm !bg-white input-bordered rounded-2xl"
                {...register("salary", {
                  required: "This field is required",
                  validate: validateSalary,
                })}
              />
              {errors.salary && (
                <span className="text-red-500">{errors.salary.message}</span>
              )}
            </div>
            {/* <span className="flex flex-col w-full gap-y-1">
              <input
                type="text"
                placeholder="Answer"
                className="input input-sm !bg-white input-bordered rounded-2xl"
                {...register("salary1", { required: true })}
              />
              {errors.job_headline && (
                <span className="text-red-500">This field is required</span>
              )}
            </span> */}
          </div>
        </div>

        <div className="mt-3 form-control">
          <label className="label">
            <span className="font-semibold ">Rate Per Hour</span>
          </label>

          <input
            type="text"
            placeholder="Answer"
            className="input input-sm !bg-white input-bordered rounded-2xl"
            {...register("rate_per_hour", { required: true })}
          />
          {errors.rate_per_hour && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>
        <div className="mt-3 form-control ">
          <label>Experience Level</label>
          <select
            {...register("experience_level")}
            className="p-1 rounded-xl bg-base-100"
          >
            <option value="0-1 years">0-1 years of experience</option>
            <option value="1-2 years">1-2 years of experience</option>
            <option value="3-5 years">3-5 years of experience</option>
            <option value="6 years plus">6+ years of experience</option>
          </select>
          {errors.experience && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>

        <div className="form-control">
          <label className="label">
            <span className="font-semibold">Job Description</span>
          </label>
          <ReactQuill
            value={jobDescription}
            onChange={(value) => setValue("job_description", value)}
            modules={{
              toolbar: [
                [{ header: "1" }, { header: "2" }, { font: [] }],
                [{ size: [] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [
                  { list: "ordered" },
                  { list: "bullet" },
                  { indent: "-1" },
                  { indent: "+1" },
                ],
                ["clean"],
              ],
            }}
            className="rounded-2xl "
            style={{ height: "100px" }}
          />

          {errors.job_description && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>
        <div className="pt-10 form-control">
          <label className="label">
            <span className="font-semibold">Job Requirements</span>
          </label>
          <ReactQuill
            value={jobRequirements}
            onChange={(value) => setValue("job_requirements", value)}
            modules={{
              toolbar: [
                [{ header: "1" }, { header: "2" }, { font: [] }],
                [{ size: [] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [
                  { list: "ordered" },
                  { list: "bullet" },
                  { indent: "-1" },
                  { indent: "+1" },
                ],
                ["clean"],
              ],
            }}
            className="rounded-2xl "
            style={{ height: "100px" }}
          />

          {errors.job_requirements && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>
        <button className="mt-12 btn btn-success" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
};

export default PostAJob;
